import { Component, Input } from '@angular/core';
import { CommonService } from '../../service/common.service';

@Component({
    selector: 'app-card-skeleton-loader',
    templateUrl: './card-skeleton-loader.component.html',
    standalone: false
})
export class CardSkeletonLoaderComponent {
  currentUrl: any;
  constructor(public _commonservice: CommonService) {}
   @Input() openUploadDetails:string = ''; 

}
